export const GET_LABTESTORDER_FOR_PATIENT = "GET_LABTESTORDER_FOR_PATIENT";
export const SET_ACTIVE_LABTESTORDER = "SET_ACTIVE_LABTESTORDER";
export const POST_LABTESTORDER = "POST_LABTESTORDER"